<template>
    <div>
        <el-select v-model="Tprovince" placeholder="请选择省份" size="mini" value-key="id"
                   @visible-change="handleChangeFlag" @change="handleGetCityList">
            <el-option v-for="(item, index) in provinceOption" :key="index" :label="item.Name"
                       :value="item.Id"></el-option>
        </el-select>
        <el-select v-model="Tcity" placeholder="请选择城市" size="mini" value-key="id"
                   @visible-change="handleChangeFlag" @change="handleGetAreaList">
            <el-option v-for="(item, index) in cityOption" :key="index" :label="item.Name" :value="item.Id"></el-option>
        </el-select>
        <el-select v-model="Tarea" placeholder="请选择区县" size="mini" value-key="id"
                   @visible-change="handleChangeFlag" @change="handleGetStreetList">
            <el-option v-for="(item, index) in countyOption" :key="index" :label="item.Name"
                       :value="item.Id"></el-option>
        </el-select>
        <el-select v-model="Tstreet" placeholder="请选择街道" size="mini" value-key="id"
                   @visible-change="handleChangeFlag" @change="handleGetList">
            <el-option v-for="(item, index) in streetOption" :key="index" :label="item.Name"
                       :value="item.Id"></el-option>
        </el-select>
    </div>


</template>

<script>
    export default {
        props: {
            province: Number,
            city: Number,
            area: Number,
            street: Number,
        },
        name: "changeAddress",
        data() {
            return {
                Tprovince: this.province,
                Tcity: this.city,
                Tarea: this.area,
                Tstreet: this.street,


                changeFlag: false,
                provinceOption: [],  //省
                cityOption: [],  //市
                countyOption: [], //区
                streetOption: [], //街道
            }
        },
        mounted() {
            this.initCityList();
        },
        methods: {
            handleGetCityList(value) {  //省 改动时
                const data = this.provinceOption.find(item => item.Id === value);
                this.getList(2, data.Id, "cityOption", true, 'Tcity');
            },
            handleGetAreaList(value) {//市  改动时
                const data = this.cityOption.find(item => item.Id === value);
                this.getList(3, data.Id, "countyOption", true, 'Tarea');
            },
            handleGetStreetList(value) { //区 改动时
                const data = this.countyOption.find(item => item.Id === value);
                this.getList(4, data.Id, "streetOption", true, 'Tstreet');
            },
            handleGetList(value) { //街道 改动时
                this.$emit('change', {
                    province: this.Tprovince,
                    city: this.Tcity,
                    area: this.Tarea,
                    street: this.Tstreet,
                })
            },

            handleChangeFlag(type) {// select回调，判断当前下拉框是否展示
                this.changeFlag = type;
            },
            getList(level, ParentId, valname, changeNext, name) { //获取四级联动接口
                //当前层级，父ID，当前变量数组名字，是否递归，递归设置默认值名字
                var _this = this;
                this.$axios.post("http://api.monitor.hzjly.cn/Address/PlaceName", {
                    Level: level, ParentID: ParentId
                })
                    .then(res => {
                        _this[valname] = res.data;
                        if (changeNext) {
                            _this[name] = _this[valname][0].Id;
                            switch (parseInt(level + 1)) {
                                case 3:
                                    _this.getList(3, _this[valname][0].Id, "countyOption", true, 'Tarea');
                                    break;
                                case 4:
                                    _this.getList(4, _this[valname][0].Id, "streetOption", true, 'Tstreet');
                                    break;
                            }
                        }
                        this.$emit('change', {
                            province: this.Tprovince,
                            city: this.Tcity,
                            area: this.Tarea,
                            street: this.Tstreet,
                        })
                    })
                    .catch(err => {

                    });



            },
            initCityList() {  //初始化
                this.getList(1, "0", "provinceOption");            //获取三级联动 省
                this.getList(2, "330000", "cityOption");           //获取三级联动 市
                this.getList(3, "330100", "countyOption");         //获取三级联动 区
                this.getList(4, "330104", "streetOption");         //获取三级联动 街道
            }

        }
    }
</script>

<style scoped>
.el-select{
  margin-right: 15px;
}
</style>